import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5be2493e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StoryblokImage: require('/opt/build/repo/components/StoryblokImage.vue').default,AppCarousel: require('/opt/build/repo/components/AppCarousel.vue').default,BoutiqueInfos: require('/opt/build/repo/components/BoutiqueInfos.vue').default,ProductGrid: require('/opt/build/repo/components/ProductGrid.vue').default})
